// ApolloClient.js
import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';
import { onError } from '@apollo/client/link/error';
import { getBaseURL } from './utils/baseUrl';
import { getLocalSelectedDevice } from './utils/selectedDevice';
// Base URL
const baseURL = getBaseURL();

let failedRequestCount = 0;

// Error monitoring link
const errorLink = onError(({ networkError, graphQLErrors }) => {
  const selectedDevice = getLocalSelectedDevice();
  const primaryDeviceScode = localStorage.getItem('PSC');

  if (selectedDevice?.Scode !== primaryDeviceScode) {
    if (networkError || graphQLErrors) {
      failedRequestCount += 1;

      if (failedRequestCount >= 20) {
        const event = new CustomEvent('consecutiveFailures', { detail: failedRequestCount });
        window.dispatchEvent(event);

        // Reset count after dispatching
        failedRequestCount = 0;
      }
    } else {
      // Reset on success
      failedRequestCount = 0;
    }
  }
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('SESSION_ID');
  const jwtCookie = localStorage.getItem('COOKIE_ID');

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      authorization: token || '',
      'cf-access-token': jwtCookie || '',
      ...headers,
    },
  };
});

const uploadLink = createUploadLink({ uri: baseURL });
const combinedLink = ApolloLink.from([errorLink, authLink.concat(uploadLink)]);

const client = new ApolloClient({
  link: combinedLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default client;
